import { SalaryTextInput } from "@monsterindia/global-ui-components";
import React, { memo } from "react";
import { Controller } from "react-hook-form";

import { SalaryInputControllerProps } from "./salaryInputController.types";

const SalaryInputController = ({
  name,
  control,
  currency,
  setCurrency,
  absoluteSalary,
  setAbsoluteSalary,
  isRequired,
  placeholder,
  errorMessage,
  tooltipText,
  isSalaryAnnual = true,
}: SalaryInputControllerProps) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={
        isRequired
          ? {
              required: "This field is required",
              validate: (value) => value > 0 || "Salary value cannot be 0.",
            }
          : { validate: (value) => value > 0 || "Salary cannot be 0." }
      }
      render={({ field }) => {
        return (
          <SalaryTextInput
            countryCurrency={currency}
            setCountryCurrency={(value: unknown) => {
              setCurrency(value);
            }}
            absoluteSalary={field.value ? field.value : (absoluteSalary ?? "")}
            setAbsoluteSalary={(value: string) => {
              setAbsoluteSalary(value);
            }}
            required={true}
            placeholder={placeholder}
            errorText={errorMessage}
            isNumberToWords={errorMessage ? false : true}
            isSalaryAnnual={isSalaryAnnual}
            tooltipText={tooltipText}
          />
        );
      }}
    />
  );
};

export default memo(SalaryInputController);
